import * as zod from 'zod';

/**
 * Physical connector on the end effector board used for RS485 communication.
 *
 * - M8: Standard end effector port (interfaceId 0)
 * - M12: Auxiliary tool port on Thor EE (interfaceId 1)
 */
export const EndEffectorConnectorOptions = ['M8', 'M12'] as const;
export const EndEffectorConnector = zod
  .enum(EndEffectorConnectorOptions)
  .default('M8');
export type EndEffectorConnector = zod.infer<typeof EndEffectorConnector>;

const CONNECTOR_TO_INTERFACE_ID: Record<EndEffectorConnector, number> = {
  M8: 0,
  M12: 1,
};

/** Map connector name to firmware interfaceId */
export function connectorToInterfaceId(
  connector: EndEffectorConnector,
): number {
  return CONNECTOR_TO_INTERFACE_ID[connector];
}

/**
 * Derive the firmware interfaceId from a device configuration that may or may
 * not carry a `connector` field. Legacy configs without `connector` fall back
 * to 0 (primary RS485).
 */
export function getInterfaceIdFromConfig(config: object): number {
  if ('connector' in config) {
    return connectorToInterfaceId(
      (config as { connector: EndEffectorConnector }).connector,
    );
  }

  return 0;
}
